<template>  

  <div class="mt-8 grid grid-cols-2 gap-4 md:mb-4">
    <div class="flex justify-start">
      <button v-if="onPrev" @click="onPrev"
        :class="`inline-flex items-center justify-center whitespace-nowrap !uppercase text-black  py-2.5 text-sm font-medium hover:text-gray-600 focus:outline-none shadow-none ${roundedClass}`">
        <ArrowLeftIcon class="w-5 h-5 text-black mr-2" />
        {{ onPrevTitle ?? "Wróć" }}
      </button>
    </div>
    
    <div class="flex justify-end">
      <button v-if="onNext" :type="buttonType" :disabled="disabled" @click="handleNext"
        :class="`primary-button w-40 leading-6 inline-flex justify-center whitespace-nowrap  ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`">
        {{ onNextTitle ?? "Dalej" }}
      </button>
    </div>
  </div>
</template> 

<script>
import { ArrowLeftIcon } from '@heroicons/vue/24/outline';
import Globals from '@shared/model/Globals.js';

export default {
  props: {
    onNext: Function,
    onNextTitle: String,
    canProceed: Function,
    onPrev: Function,
    onPrevTitle: String,
    buttonType: {
      type: String,
      default: 'button'
    }
  },
  components: {
    ArrowLeftIcon
  },
  computed: {
    disabled() {
      if (!this.canProceed) {
        return false; // If canProceed is not provided, do not disable the button
      }
      return this.canProceed && !this.canProceed();
    },
    roundedClass() {
      return Globals.getRoundedClass();
    }
  },
  methods: {
      async handleNext(event){
        // prevent multiple quick clicks
        if (this.isProcessing) return;
        this.isProcessing = true;

        try {
          if (event && event.preventDefault) event.preventDefault();

          if (this.buttonType === 'submit') {
            const form = event && event.target ? event.target.closest('form') : null;
            if (form) {
              const valid = form.checkValidity();
              if (!valid) {
                form.reportValidity();
                return false;
              }
              const submitEvent = new Event('submit', { cancelable: true, bubbles: true });
              form.dispatchEvent(submitEvent);
              if (!form.checkValidity()) {
                return;
              }
            }
          }

          if (this.onNext) {
            if (this.canProceed && !this.canProceed()) {
              console.warn('Cannot proceed, canProceed function returned false');
              return;
            }
            // support async handlers
            await this.onNext();
          }
        } finally {
          this.isProcessing = false;
        }
      }
    
    
  }
}
</script>

<style scoped>
/* Add any necessary styles here */
</style>